import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage10.module.css"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/theDemiurgos.json";

export default function LaymanPage10() {
  return (
    <>
       <Common_html BlockData={BlockData} />
    </>
  )
}